import axios from 'axios';

export const fetchRecipeByCategoryId = async (id) =>
  axios
    .get(
      `https://app.rakuten.co.jp/services/api/Recipe/CategoryRanking/20170426?format=json&categoryId=${id}&applicationId=1085391852071960406`
    )
    .then((results) => {
      const data = results.data.result;

      return data;
    });
